import { Routes, Route, Navigate } from "react-router-dom";
import { AuthRouteGuard, ProtectedRouteGuard } from "../guards/LoggedInGuard.jsx";

import Login from "../components/Auth/Login/Login.jsx";
import ForgotPasswordForm from "../components/Auth/ForgotPassword/ForgotPassword.jsx";
import AdminDashboard from "../pages/AdminDashboard/AdminDashboard.jsx";
import SaddleAdmin from "../pages/SaddleAdmin/SaddleAdmin.jsx";
import BrandOrders from "../pages/Orders/BrandOrders.jsx";
import OrderTracking from "../pages/OrderTracking/index.jsx";
import AllQueries from "../components/AllQueries/AllQueries.jsx";
import EventPage from "../pages/EventManagement/EventPage.jsx";
import BookingManagement from "../pages/BookingManagement/BookingManagement.jsx";
import BannerSection from "../pages/BannerSection/BannerSection.jsx";
import Banner from "../pages/Banner/Banner.jsx";
import CreateSaddle from "../pages/Saddle/AddSaddle.jsx";
import HorseAdmin from "../pages/HorseAdmin/HorseAdmin.jsx";
import EditHorse from "../pages/HorseAdmin/EditHorse.jsx";
import HorseOwnership from "../pages/HorseAdmin/HorseOwnership.jsx";
import Manufacturers from "../pages/Manufacturers/index.jsx";
import CreateManufacture from "../pages/Manufacturers/CreateManufacture.jsx";
import OnBoarding from "../pages/Onboarding/index.jsx";
import Profile from "../pages/Profile/index.jsx";
import ShopifyConnect from "../pages/ShopifyConnect/index.jsx";
import ShopifyProcessing from "../pages/ShopifyConnect/Processing.jsx";
import ShopifyCallback from "../pages/ShopifyConnect/Callback.jsx";
import StripeConnect from "../pages/StripeConnect/index.jsx";
import { useUserContext } from "../context/UserContext.jsx";
import ManufacturerDetails from "../pages/Manufacturers/ManufacturerDetails.jsx";
import Teams from "../pages/Manufacturers/Teams.jsx";
import NotFound from "../pages/NotFound/NotFound.jsx";
import CustomSaddleOrders from "../pages/Admin/CustomSaddleOrders/index.jsx";
import Settings from "../pages/Settings/index.jsx";
import FileBrowser from "../pages/FileBrowser/index.jsx";
import EventBookingRedirect from "../pages/EventBookingRedirect.jsx";

function Router() {
  const { userData } = useUserContext();
  const isSimpleAdmin =
    userData?.brand !== "saddlefitadmin" && (userData?.type === "Admin" || userData?.type === "Member");

  return (
    <Routes>
      <Route path="/" element={<AuthRouteGuard element={Login} />} />
      <Route
        path="/forgot-password"
        element={<AuthRouteGuard element={ForgotPasswordForm} />}
      />

      <Route path="/event" element={<EventBookingRedirect />} />

      <Route element={<ProtectedRouteGuard />}>
        <Route path="/admin-dashboard" element={<AdminDashboard />} />
        <Route path="/saddle-admin" element={<SaddleAdmin />} />


        {/* Orders Routes dynamic route for any brands */}
        <Route path="/orders/:brandSlug" element={<BrandOrders />} />
        <Route path="/order/:id" element={<OrderTracking />} />

        {/* Other pages */}
        <Route path="/all-queries" element={<AllQueries />} />
        <Route path="/event-management" element={<EventPage />} />
        <Route path="/booking-management" element={<BookingManagement />} />
        <Route path="/banner-section" element={<BannerSection />} />
        <Route path="/banner" element={<Banner />} />
        <Route path="/saddles/manage/:encodedId?" element={<CreateSaddle />} />
        <Route path="/horse-admin" element={<HorseAdmin />} />
        <Route path="/horse-admin/horse/edit/:horseId" element={<EditHorse />} />
        <Route
          path="/horse-admin/horse/transferOwnership/:horseId"
          element={<HorseOwnership />}
        />

        {/* Custom Saddle Orders Admin */}
        <Route path="/custom-saddle-orders" element={<CustomSaddleOrders />} />

        <Route path="/manufacturers" element={<Manufacturers />} />
        <Route path="/manufacturers/create" element={<CreateManufacture />} />
        <Route path="/manufacturers/:id" element={<ManufacturerDetails />} />
        <Route path="/team-members" element={<Teams />} />
        <Route path="/onboarding" element={<OnBoarding />} />
        <Route path="/shopify-connect" element={<ShopifyConnect />} />
        <Route path="/shopify/processing" element={<ShopifyProcessing />} />
        <Route path="/shopify/callback" element={<ShopifyCallback />} />
        <Route path="/stripe-connect" element={<StripeConnect />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/file-browser" element={<FileBrowser />} />
      </Route>

      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

export default Router;
